import {
  AppstoreOutlined,
  AuditOutlined,
  FileDoneOutlined,
  FileExclamationOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  LockFilled,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  PlusSquareOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';
import { Menu } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import Sider from 'antd/lib/layout/Sider';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { NavLink, useLocation, useRouteMatch } from 'react-router-dom';
import { CONFIG, TIPOS_PRODUCTOS, USER_STATES } from './constants';
import EmpresaContext from './context/empresa-context';
import UserContext from './context/user-context';
import { getIcon, puedeMostrarMenu, rutasPorGrupo } from './utils';

const { SubMenu } = Menu;

const styles = {
  sider: {
    overflow: 'auto',
    height: '100vh',
    position: 'fixed',
    left: 0,
    zIndex: 11
  },
  toggle: {
    color: 'white',
    fontSize: 20,
    flex: 1,
    paddingTop: 16,
    paddingLeft: 16,
    paddingRight: 16,
    textAlign: 'right'
  },
  menuItem: {
    fontWeight: 600
  },
  menuIcon: {
    fontSize: 16
  }
};

const ProtectedMenu = ({ to, key, text, onClick, icon, ...rest }) => {
  const { user } = useContext(UserContext);
  const [puedeIngresar, setPuedeIngresar] = useState();

  useEffect(() => {
    if (
      user &&
      user['cognito:groups'] &&
      rutasPorGrupo[user['cognito:groups'][0]]
    ) {
      setPuedeIngresar(
        rutasPorGrupo[user['cognito:groups'][0]].filter((item) =>
          to.startsWith(item)
        ).length > 0
      );
    }
  }, [user, to]);

  return puedeIngresar ? (
    <Menu.Item key={key} onClick={onClick} icon={icon} {...rest}>
      <NavLink to={to}>{text}</NavLink>
    </Menu.Item>
  ) : null;
};
const getMenuItem = ({ to, key, text, icon, ...rest }) => {
  return {
    icon,
    key,
    label: to ? <NavLink to={to}>{text}</NavLink> : text,
    // title: text,
    ...rest
  };
};

export const CustomSubMenu = ({
  to,
  key,
  text,
  onClick,
  icon,
  title,
  hideMenu,
  ...rest
}) => {
  const { user } = useContext(UserContext);
  const [puedeIngresar, setPuedeIngresar] = useState();
  useEffect(() => {
    if (
      user &&
      user['cognito:groups'] &&
      rutasPorGrupo[user['cognito:groups'][0]]
    ) {
      const rutasAVerificar = rutasPorGrupo[user['cognito:groups'][0]];
      const toList = rest.children.map((subitem) => subitem.props.to);
      let rutaEncontrada = false;
      for (let i = 0; i < rutasAVerificar.length; i += 1) {
        const item = rutasAVerificar[i];
        rutaEncontrada = toList.find((toItem) => toItem.startsWith(item));
        if (rutaEncontrada) {
          break;
        }
      }
      setPuedeIngresar(rutaEncontrada);
    }
  }, [rest.children, user]);

  return puedeIngresar ? (
    <SubMenu
      key={key}
      onClick={onClick}
      icon={icon}
      title={title}
      {...rest}
      // collapsed
    >
      {rest.children}
    </SubMenu>
  ) : null;
};

const SideMenu = ({ collapsed, onChangeCollapsed }) => {
  const { empresa, productos, updateProducto } = useContext(EmpresaContext);
  const { user, userState } = useContext(UserContext);
  const screens = useBreakpoint();
  const [openKeys, setOpenKeys] = useState([]);
  const [tieneGestionSistema, setTieneGestionSistema] = useState();
  const location = useLocation();

  const {
    params: { item }
  } = useRouteMatch();
  const getLink = (producto) => {
    const active = TIPOS_PRODUCTOS.find(
      ({ codigo }) => codigo === producto.codigo
    );
    if (active) {
      return active.link;
    }
    return '/';
  };

  const puedeIngresar = useCallback(
    (to) => {
      if (
        user &&
        user['cognito:groups'] &&
        rutasPorGrupo[user['cognito:groups'][0]]
      ) {
        return (
          rutasPorGrupo[user['cognito:groups'][0]].filter((element) =>
            to.startsWith(element)
          ).length > 0
        );
      }
      return false;
    },
    [user]
  );

  const getProtectedMenuItem = (props) => {
    if (props.to) {
      return puedeIngresar(props.to) && getMenuItem(props);
    }
    return getMenuItem(props);
  };

  useEffect(() => {
    if (collapsed) {
      setOpenKeys([]);
    } else {
      setOpenKeys(['productos']);
    }
  }, [collapsed]);

  useEffect(() => {
    if (user) {
      if (user.usuarioSegu.gestion_sistema) {
        setTieneGestionSistema(true);
      } else {
        setTieneGestionSistema(false);
      }
    }
  }, [user]);

  if (!puedeMostrarMenu(location.pathname, user, userState)) {
    return null;
  }

  const hideMenu = () => {
    if (screens.md === false) {
      onChangeCollapsed(true);
    }
  };

  const toggleCollapsed = () => {
    const localCollapsed = localStorage.getItem('collapsed');
    const parsedCollapsed = localCollapsed ? JSON.parse(localCollapsed) : false;
    localStorage.setItem('collapsed', !parsedCollapsed ? 'true' : 'false');
    onChangeCollapsed(!collapsed);
  };

  const esClienteONoEstaLogueado =
    (user && user['cognito:groups'][0] === 'CLIENTE') ||
    (!user &&
      (userState === USER_STATES.loggingEnd ||
        userState === USER_STATES.notLogged));
  return (
    <Sider
      trigger={null}
      style={{
        ...styles.sider,
        boxShadow:
          (screens.md === undefined || screens.md === false) &&
          '15px 0px 15px -10px rgba(0,0,0,0.75)'
      }}
      collapsible
      collapsed={collapsed}
      onCollapse={toggleCollapsed}
      width={collapsed ? undefined : 300}
      {...((screens.md === undefined || screens.md === false) && {
        collapsedWidth: '0'
      })}
    >
      <div
        style={{
          ...styles.toggle,
          textAlign: collapsed ? 'center' : 'right'
        }}
      >
        {puedeMostrarMenu(location.pathname, user, userState) && (
          <>
            {React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                className: 'trigger',
                onClick: () => toggleCollapsed()
              }
            )}
          </>
        )}
      </div>
      <Menu
        theme="dark"
        defaultSelectedKeys={[item]}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        mode="inline"
        onClick={hideMenu}
        inlineCollapsed={collapsed}
        className="custom-menu"
        items={[
          ...(user && user.name
            ? [
                ...(tieneGestionSistema ||
                user['cognito:groups'][0] === 'CLIENTE'
                  ? [
                      getProtectedMenuItem({
                        to: '/panel',
                        key: 'panel',
                        text: 'Tablero',
                        onClick: hideMenu,
                        icon: <PieChartOutlined style={styles.menuIcon} />,
                        style: styles.menuItem
                      }),
                      user['cognito:groups'][0] === 'CLIENTE'
                        ? getProtectedMenuItem({
                            to: '/cotizaciones',
                            key: 'cotizaciones',
                            text: 'Cotizaciones',
                            icon: <FileTextOutlined style={styles.menuIcon} />,
                            style: styles.menuItem
                          })
                        : getProtectedMenuItem({
                            key: 'cotizacion',
                            icon: <FileTextOutlined style={styles.menuIcon} />,
                            text: 'Cotizaciones',
                            style: styles.menuItem,
                            children: [
                              getProtectedMenuItem({
                                to: '/crearcotizacion',
                                key: 'crearcotizacion',
                                text: 'Crear cotización',
                                icon: (
                                  <PlusSquareOutlined style={styles.menuIcon} />
                                ),
                                style: styles.menuItem
                              }),
                              getProtectedMenuItem({
                                to: '/cotizaciones',
                                key: 'listado-cotizaciones',
                                text: 'Listado',
                                icon: (
                                  <UnorderedListOutlined
                                    style={styles.menuIcon}
                                  />
                                ),
                                style: styles.menuItem
                              }),
                              CONFIG.AMBIENTE !== 'production' &&
                                getProtectedMenuItem({
                                  to: '/crearcotizacionmasiva',
                                  key: 'crearcotizacionmasiva',
                                  icon: <PlusSquareOutlined />,
                                  text: 'Crear Cotización Masiva',
                                  style: styles.menuItem
                                }),
                              CONFIG.AMBIENTE !== 'production' &&
                                getProtectedMenuItem({
                                  to: '/cotizacionesmasivas',
                                  key: 'listado-cotizaciones-masivas',
                                  icon: <UnorderedListOutlined />,
                                  text: 'Listado Cotizaciones Masivas',
                                  style: styles.menuItem
                                })
                            ]
                          }),
                      getProtectedMenuItem({
                        to: '/solicitudes',
                        key: 'solicitudes',
                        text: 'Solicitudes',
                        icon: <FileDoneOutlined style={styles.menuIcon} />,
                        style: styles.menuItem
                      }),
                      getProtectedMenuItem({
                        to: '/inspecciones',
                        key: 'inspecciones',
                        text: 'Inspecciones',
                        icon: <AuditOutlined style={styles.menuIcon} />,
                        style: styles.menuItem
                      }),
                      getProtectedMenuItem({
                        to: '/polizas',
                        key: 'polizas',
                        text: 'Pólizas',
                        icon: <FileProtectOutlined style={styles.menuIcon} />,
                        style: styles.menuItem
                      }),
                      empresa?.tiene_siniestros &&
                        getProtectedMenuItem({
                          key: 'siniestro',
                          icon: (
                            <FileExclamationOutlined style={styles.menuIcon} />
                          ),
                          text: 'Siniestros',

                          style: styles.menuItem,
                          children: [
                            getProtectedMenuItem({
                              to: '/denuncia-siniestro',
                              key: 'denuncia-siniestro',
                              text: 'Denuncia',
                              icon: (
                                <PlusSquareOutlined style={styles.menuIcon} />
                              ),
                              style: styles.menuItem
                            }),
                            getProtectedMenuItem({
                              to: '/siniestros',
                              key: 'listado',
                              text: 'Listado',
                              icon: (
                                <UnorderedListOutlined
                                  style={styles.menuIcon}
                                />
                              ),
                              style: styles.menuItem
                            })
                          ]
                        })
                    ]
                  : []),
                tieneGestionSistema &&
                  getProtectedMenuItem({
                    to: '/autorizaciones',
                    key: 'autorizaciones',
                    text: 'Autorizaciones',
                    icon: <LockFilled style={styles.menuIcon} />,
                    style: styles.menuItem
                  })
              ]
            : []),
          productos &&
            productos.length > 0 &&
            empresa?.tiene_landing &&
            esClienteONoEstaLogueado && {
              key: 'productos',
              icon: <AppstoreOutlined style={styles.menuIcon} />,
              label: 'Coberturas',
              style: styles.menuItem,
              children: productos.map((producto) =>
                getMenuItem({
                  key: `${getLink(producto)}`,
                  to: `/${getLink(producto)}`,
                  text: producto.descripcion,
                  icon: getIcon(producto.codigo, { style: styles.menuIcon }),
                  style: styles.menuItem,
                  onClick: () => {
                    updateProducto(producto.id);
                    if (screens.md === false) {
                      onChangeCollapsed(true);
                    }
                  }
                })
              )
            }
        ]}
      />
    </Sider>
  );
};
//  <ProtectedMenu
//   to="/jobs"
//   key="jobs"
//   text="Tareas Programadas"
//   onClick={hideMenu}
//   icon={<FileTextOutlined />}
// />
//   <ProtectedMenu
//   to="/siniestros"
//   key="siniestros"
//   text="Siniestros"
//   onClick={hideMenu}
//   icon={<UserOutlined />}
// />
//   <ProtectedMenu
//   to="/promociones"
//   key="promociones"
//   text="Promociones"
//   onClick={hideMenu}
//   icon={<ShopOutlined />}
// />
//   <ProtectedMenu
//   to="/proveedores"
//   key="proveedores"
//   text="Proveedores"
//   onClick={hideMenu}
//   icon={<TeamOutlined />}
// />
//   <ProtectedMenu
//   to="/comisiones"
//   key="comisiones"
//   text="Comisiones"
//   onClick={hideMenu}
//   icon={<FileTextOutlined />}
// />

export { ProtectedMenu, getMenuItem };
export default SideMenu;
